// Pure rules shared by platform generation, jumping and collision tests.
export const MAX_JUMP_DISTANCE = 112;
export function chargeDistance(progress) {
  const t = Math.max(0, Math.min(1, progress));
  return 5 + (MAX_JUMP_DISTANCE - 5) * Math.pow(t, 1.35);
}
export function platformParameters(step, random = Math.random) {
  const difficulty = Math.min(1, step / 60);
  return {
    size: 30 - difficulty * 12 + random() * 3,
    gap: 18 + difficulty * 16 + random() * (10 + difficulty * 8)
  };
}
export function landingOn(box, point, footRadius) {
  const dx = Math.abs(point.x - box.position.x);
  const dz = Math.abs(point.z - box.position.z);
  const radius = box.size / 2;
  const offset = box.shape === 'circle' ? Math.hypot(dx, dz) : Math.max(dx, dz);
  if (offset <= radius - footRadius * 0.45) {
    return offset <= Math.min(3, radius * 0.22) ? 'perfect' : 'normal';
  }
  return offset <= radius + footRadius ? 'edge' : 'miss';
}
